<template>
    <slide class="slide">

        <div class='slide-serie-logo-bg'>
            <serie-logo :serie="serie_id"/>
        </div>
        <div class="wrapper">
            <div class='col series-main-bike'>
                <div v-for="(kind,ski) in serie.kinds" v-bind:class="'serie-kind kind-' + kind"></div>
            </div>
            <div class="col series-info">
                <h2 v-html="t('sr_' + serie_id + '_hd')">Nazwa serii heading</h2>
                <p v-html="t('dsc_' + serie_id)">Opis serii</p>
                <a class="btn" :href="getLink(serie_id)"><span v-translate="'sr_explore'"> </span>&nbsp;<span>{{serie_id}}</span></a>
            </div>
        </div>

    </slide>
</template>

<script>

    import Slide from "./../Carousel/Slide";
    import SerieLogo from "../Graphics/SerieLogo";


    export default {
        props: {
            serie_id: String,
            serie: Object
        },
        name: 'SerieSlide',
        components: {
            Slide, SerieLogo
        },

        methods: {
            t: function (text) {
                return translations[text];
            },
            getLink(id) {
              return this.t('rt_bikes') + '/' + id;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/HomePage/SerieSlide.vue